import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";

const testimonials = [
  {
    id: 1,
    name: "Amira B.",
    location: "Alger",
    rating: 5,
    text: "Service exceptionnel et parfums authentiques. La livraison était rapide et le packaging très soigné. Je recommande vivement ParfumAlgérie pour tous les amoureux des belles fragrances.",
    perfume: "Nuit d'Alger",
  },
  {
    id: 2,
    name: "Mohamed K.",
    location: "Oran",
    rating: 5,
    text: "J'ai commandé plusieurs fois et je n'ai jamais été déçu. Les parfums sont originaux et le service client est très réactif. Une vraie référence en Algérie.",
    perfume: "Essence Royale",
  },
  {
    id: 3,
    name: "Lina S.",
    location: "Constantine",
    rating: 5,
    text: "Enfin une boutique de confiance pour acheter des parfums de qualité. Les prix sont justes et la sélection est magnifique. Merci ParfumAlgérie !",
    perfume: "Rose du Désert",
  },
  {
    id: 4,
    name: "Yacine D.",
    location: "Annaba",
    rating: 5,
    text: "Cadeau parfait pour ma femme. Elle était ravie de recevoir son parfum préféré. Commande facile et livraison express. Je reviendrai !",
    perfume: "Mystère Oriental",
  },
];

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  return (
    <section
      id="testimonials"
      className="py-24 md:py-32 bg-[#FAFAFA] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 md:mb-20"
        >
          <span className="font-montserrat text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4 block">
            Témoignages
          </span>
          <h2 className="font-playfair text-4xl md:text-5xl font-medium tracking-tight text-[#1A1A1A]">
            Ce Que Disent{" "}
            <span className="italic font-cormorant">Nos Clients</span>
          </h2>
        </motion.div>

        {/* Testimonial Carousel */}
        <div className="relative max-w-4xl mx-auto">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
              className="testimonial-card p-8 md:p-12 text-center"
            >
              {/* Stars */}
              <div className="flex justify-center gap-1 mb-6">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <Star
                    key={i}
                    size={18}
                    className="fill-[#D4AF37] text-[#D4AF37]"
                  />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="font-cormorant text-2xl md:text-3xl text-[#1A1A1A] leading-relaxed mb-8 italic">
                "{testimonials[currentIndex].text}"
              </blockquote>

              {/* Author */}
              <div>
                <p className="font-playfair text-xl text-[#1A1A1A] mb-1">
                  {testimonials[currentIndex].name}
                </p>
                <p className="font-montserrat text-sm text-[#999]">
                  {testimonials[currentIndex].location} •{" "}
                  <span className="text-[#D4AF37]">
                    {testimonials[currentIndex].perfume}
                  </span>
                </p>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <button
              onClick={prevTestimonial}
              className="p-3 border border-black/10 rounded-full hover:bg-[#1A1A1A] hover:text-white hover:border-[#1A1A1A] transition-all"
              data-testid="testimonial-prev-btn"
              aria-label="Previous testimonial"
            >
              <ChevronLeft size={20} />
            </button>

            {/* Dots */}
            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all ${
                    index === currentIndex
                      ? "bg-[#D4AF37] w-6"
                      : "bg-black/20 hover:bg-black/40"
                  }`}
                  data-testid={`testimonial-dot-${index}`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>

            <button
              onClick={nextTestimonial}
              className="p-3 border border-black/10 rounded-full hover:bg-[#1A1A1A] hover:text-white hover:border-[#1A1A1A] transition-all"
              data-testid="testimonial-next-btn"
              aria-label="Next testimonial"
            >
              <ChevronRight size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
